import React from 'react';
import PropTypes from 'prop-types';

import { getStep } from '../../api';

import MeasurementsStraight from './MeasurementsStraight';
import MeasurementsCurved from './MeasurementsCurved';

class Measurements extends React.PureComponent {
  state = {
    diameters: [],
    corner_bend: null,
  };

  componentDidMount() {
    if (!this.props.values.diameter) {
      this.props.setError('diameter', 'required');
    }

    getStep({ ...this.props.values, step: this.props.step }, this.props.setLoading)
      .then(
        (res) => {
          this.setState({
            diameters: res['diameters'],
            corner_bend: res['corner_bend'],
          });
        },
        (error) => {
          console.log(error);
          this.props.setError('generic', error);
        }
      );
  }

  componentWillUnmount() {
    if (this.props.errors.diameter) {
      this.props.setError('diameter');
    }
  }

  handleChange = (name, value) => {
    if (!value) {
      this.props.setError(name, 'required');
    } else {
      this.props.setError(name);
    }
  };

  handleDiameterChange = (e) => {
    const { target: { name, value } } = e;

    this.handleChange(name, value);
    this.props.setValue(name, value);
  };

  render() {
    const RailTypeExtras = this.props.values.rail_type === 'straight' ? MeasurementsStraight : MeasurementsCurved;

    return (
      <div id="mtm-measurements">
        <h3 className="mtm-step-title-sub">Diameter</h3>
        
        <select name="diameter" onChange={this.handleDiameterChange} value={this.props.values.diameter || 0}>
          <option value="0" disabled>Välj</option>
          {this.state.diameters.map((diameter) => (
            <option key={diameter.slug} value={diameter.slug}>{diameter.name}</option>
          ))}
        </select>

        <RailTypeExtras {...this.props} {...this.state} /> 
      </div>
    );
  }
}

Measurements.propTypes = {
  step: PropTypes.number.isRequired,
  values: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default Measurements;





// WEBPACK FOOTER //
// ./src/Step/steps/Measurements.js